import { useState } from 'react'
import { Card, CardBody } from 'reactstrap'
import OpportunityTable from './OpportunityTable/OpportunityTable'
import useActivityColumns from './OpportunityTable/TableColumns/useActivityColumns'
import useContactColumns from './OpportunityTable/TableColumns/useContactColumns'

const OpportunityList = () => {
    const [showContact, setShowContact] = useState(true)

    const contactColumns = useContactColumns()
    const activityColumns = useActivityColumns()

    const tableKey = showContact ? 'opportunityContactTable' : 'opportunityActivityTable'

    return (
        <Card>
            <CardBody>
                <OpportunityTable
                    key={tableKey}
                    tableKey={tableKey}
                    showContact={showContact}
                    columns={showContact ? contactColumns : activityColumns}
                    url={showContact ? 'contact/profile' : 'activity'}
                    entityType="property"
                    onToggleFilter={setShowContact}
                />
            </CardBody>
        </Card>
    )
}

export default OpportunityList
